import api from "@/plugins/api";
// The BE still names this resource "organisation settings" — the FE has renamed
// it to "workspace" to avoid clashing with the Organisation CRM entity, but the
// BFF endpoint URL stays as-is. Backed by OPUS legal-info (OP-5023).
const ENDPOINT = "/organisations/settings";
function mapResponse(data) {
    return {
        name: data.name ?? "",
        address: data.address ?? "",
        siren: data.siren ?? "",
        siret: data.siret ?? "",
        rna: data.rna ?? "",
        signatoryFunction: data.signatoryFunction ?? "",
        signatoryName: data.signatoryName ?? "",
        receiptObject: data.receiptObject ?? "",
        organizationQualification: data.organizationQualification ?? "",
        signatureUrl: data.signatureUrl ?? null,
    };
}
export async function getWorkspaceSettings() {
    const response = await api.get(ENDPOINT, {
        unwrapEnvelope: true,
    });
    return mapResponse(response.data);
}
export async function updateWorkspaceSettings(payload, signatureFile, removeSignature) {
    const formData = new FormData();
    // Always send the scalar fields: an empty value clears the field on the BE
    // (tri-state PATCH — present-and-empty means "set to NULL").
    formData.append("address", payload.address);
    formData.append("siren", payload.siren);
    formData.append("siret", payload.siret);
    formData.append("rna", payload.rna);
    formData.append("signatoryFunction", payload.signatoryFunction);
    formData.append("signatoryName", payload.signatoryName);
    formData.append("receiptObject", payload.receiptObject);
    formData.append("organizationQualification", payload.organizationQualification);
    if (signatureFile) {
        formData.append("signature", signatureFile);
    }
    else if (removeSignature) {
        formData.append("removeSignature", "true");
    }
    const response = await api.put(ENDPOINT, formData, {
        unwrapEnvelope: true,
        headers: { "Content-Type": "multipart/form-data" },
    });
    return mapResponse(response.data);
}
